import React from "react";

import styles from "./Contact.module.css";

export default function Map({ width = 600, height = 450 }) {
    return (
        <div>
            <iframe
                className={styles.map}
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d20576.21554797132!2d24.011942221704103!3d49.86073852270828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1suk!2sua!4v1678226869581!5m2!1suk!2sua"
                width={width}
                height={height}
                loading="lazy"
            ></iframe>
        </div>
    );
}
